import jwtDecode from 'jwt-decode'
interface DecodedToken {
  _id: string
  name: string
  email: string
  iat: number
  exp: number
}
export const validatePasswordLong = (value: string) => {
  const regexLong = /^.{8,50}$/ // longitud de 8 a 50 caracteres

  const long = regexLong.test(value)

  if (long) {
    return true
  } else {
    return false
  }
}

export const validatePassword = (value: string) => {
  const regexUppercase = /[A-Z]/
  const regexLowercase = /[a-z]/
  const regexNum = /[0-9]/
  const regexSpecial = /[!@#$%^&*(),.?":{}|<>]/
  const minLength = 8

  const hasUppercase = regexUppercase.test(value)
  const hasLowercase = regexLowercase.test(value)
  const hasNum = regexNum.test(value)
  const hasSpecial = regexSpecial.test(value)
  const hasMinLength = value.length >= minLength

  return hasUppercase && hasLowercase && hasNum && hasSpecial && hasMinLength
}

export const getToken = () => {
  const cookies = document.cookie

  const cookie = cookies
    .split('; ')
    .find((row) => row.startsWith('token='))
    ?.split('=')[1]

  return cookie
}

export const getTokenExpiration = () => {
  const token = getToken()
  if (!token) {
    return null
  }

  try {
    const decodedToken = jwtDecode<DecodedToken>(token)
    const exp = decodedToken.exp
    const expirationDate = new Date(exp * 1000)

    return expirationDate < new Date()
  } catch (error) {
    console.error(error)
    return null
  }
}

export const formatDate = (dateString: string) => {
  const date = new Date(dateString)

  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }

  const formattedDate = date.toLocaleDateString('es-ES', options)
  return formattedDate
}

export const formatDateShort = (dateString: string) => {
  const date = new Date(dateString + 'T00:00:00')

  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
  }

  const formattedDate = date.toLocaleDateString('es-ES', options)
  return formattedDate
}

export const formatDateLong = (dateString: string) => {
  const date = new Date(dateString)

  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }

  const formattedDate = date.toLocaleDateString('es-ES', options)
  return formattedDate
}

export const formatDateToReport = (dateString: string): string => {
  const date = new Date(dateString)

  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)

  return `${year}-${month}-${day}`
}

export const logOut = () => {
  document.cookie = 'token=; expires=Thu, 01 Jan 2000 00:00:00 UTC; path=/;'
  sessionStorage.clear()
  window.location.href = '/login'
}

export const formatNumberWithDots = (number: number | undefined) => {
  if (!number) return 0
  else return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
